import "./App.css";
import Footer from "./components/footer";
import HeaderLogo from "./components/headerLogo";
import ReviewSites from "./components/reviewsites";
import Terms from "./components/terms";
import TermsText from "./components/termsText";
import ThankYou from "./components/thankyou";

function App() {
  const params = new URL(window.location.href).searchParams;
  const cId = params.get("clientId");
  const rId = params.get("requestId");

  return (
    <div className="App">
      <div id="reviewrequest">
        <HeaderLogo urlData={{ clientId: cId, requestId: rId }} />
        <div className="main-section-container">
          <ThankYou />
          <ReviewSites urlData={{ clientId: cId, requestId: rId }} />
        </div>
        <div className="separator"></div>
        <Terms />
        <Footer />
      </div>
      <div id="termsconditions" className="hidden">
        <TermsText />
      </div>
    </div>
  );
}

export default App;
